document.addEventListener('DOMContentLoaded', function() {

  const $pagegrids = jQuery('.block-page-grid');
  if( $pagegrids.length == 0 ) return;

  $pagegrids.each(function() {
    var $pagegrid = jQuery(this);
    var blockid = $pagegrid.attr('id');
    var panelid = `Panel-${blockid}`;
    var $block = jQuery(`#${blockid}`);

    $pagegrid.find('.item-page-panel a').on('click', function(e) {
      e.preventDefault();

      var url = jQuery(this).attr('href');
      $block.addClass('loading');
      try {
        jQuery.get(url, function (data) {
          try {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(data, "text/html");
            console.log( htmlDoc);
            jQuery(`#${panelid} .content-ajax`).html(htmlDoc.body.innerHTML)
            window.panel_open(panelid);
          } catch (e) {
            console.log(e);
          }
        })
          .fail(function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
          })
          .always(function () {
            $block.removeClass('loading');
          });
      } catch (e) {
        $block.removeClass('loading');
      }
    });
  });


});